import { render, staticRenderFns } from "./comment-content.vue?vue&type=template&id=5942138c&scoped=true&"
import script from "./comment-content.vue?vue&type=script&lang=js&"
export * from "./comment-content.vue?vue&type=script&lang=js&"
import style0 from "./comment-content.vue?vue&type=style&index=0&id=5942138c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942138c",
  null
  
)

export default component.exports